export class Message {
  sessionID: string;
  messageType: number;
  showText: string;
  showTitle: string;
  showImage: string;
  buttonOkText: string;
  buttonYesText: string;
  buttonNoText: string;
  buttonCancelText: string;
  environment: string;
  showButtonText: ButtonTextDetails[] = [];
}

export class ButtonTextDetails {
  buttonText: string;
  buttonMessageType: number;
  answerCode: number;
  environment: string;
}
